import React from 'react'
import Link from 'gatsby-link'


const ResourceBlock = ({ data }) => (
    <div>
        {
            ( data.flexSections && data.flexSections.length > 0 && data.flexSections[0].bannerImage ) &&
                <a href={`/${data.slug}`}>
                    <div className="featured-image">
                        <img src={ data.flexSections[0].bannerImage.file.url } alt={ data.title } />
                    </div>
                </a>
        }
        {
            !data.flexSections[0].bannerImage && data.academyStoryPreviewImage &&
            <a href={`/${data.slug}`}>
                <div className="featured-image">
                    <img src={ data.academyStoryPreviewImage.file.url } alt={ data.title } />
                </div>
            </a>

        }

        <a href={ `/${data.slug}`}><h3 style={{ textTransform:'initial', marginBottom:'8px' }} className="h3" dangerouslySetInnerHTML={{ __html: data.title }} /></a>
        {
            (data.gapYearResourcesExcerptText || data.introText.introText) &&
            <p dangerouslySetInnerHTML={{ __html: data.gapYearResourcesExcerptText ? data.gapYearResourcesExcerptText : data.introText.introText }} />
        }
        <a style={{ marginTop:'10px', display:'inline-block', cursor:'pointer' }} className="hoverlink" href={ `/${data.slug}`}>Read More</a>
    </div>
)

export default ResourceBlock



// WEBPACK FOOTER //
// ./src/components/ResourceBlock/index.js